module.exports = __webpack_public_path__ + "static/media/20k.21995ed2.svg";